module.exports = __webpack_public_path__ + "static/dl2-stay-human_darkness-e2d533d27684d88e46c0eeaea79de5d3.png";